// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"dd31006766--tooltip--slBfg","arrow":"dd31006766--arrow--wuhV1"};